<div class="policyWidget beneWidget printFormWidget">
  <div class="wrap wrapClose">
    <button type="button" class="close" onclick="window.parent.HAVENWIDGET.close();">Close</button>
  </div>

  <div class="wrap wrapHead">
    <div class="pageHead">
      <h1>Complete your beneficiary update, Massachusetts</h1>
      <div class="subhead">Just a few more steps are needed to complete your update.</div>
    </div>
  </div>

  <div class="wrap wrapMain">
    <div class="steps">
      <h2>Next steps</h2>
      <ol>
        <li>
          <h3>Print</h3>
          <p>
            Print your complete
            <a href="#" target="_blank">beneficiary update form</a>
          </p>
        </li>
        <li>
          <h3>Sign</h3>
          <p>Sign and date your printed form. A witness signature is also required.</p>
        </li>
        <li>
          <h3>Email</h3>
          <p>
            Email your signed form to
            <a href="mailto:help@havenlife.com" target="_blank">help@havenlife.com</a>
          </p>
        </li>
      </ol>
      <div class="info">
        After the form is returned to
        <a href="mailto:help@havenlife.com" target="_blank">help@havenlife.com</a>
        , you will receive a confirmation email when all changes have been processed.
      </div>
    </div>
  </div>

  <div class="wrap wrapFoot">
    <div class="cta">
      <button type="button" class="btnReturn">Return to my policy</button>
    </div>
  </div>
</div>
